import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const TAG_PATTERN = /<(terms|privacy)>(.*?)<\/\1>/g;
const LINK_CLASS = "text-brand underline underline-offset-2 hover:text-brand-hover focus-visible:shadow-focus rounded-sm";
/**
 * The agreement sentence with its Terms and Privacy links. Renders a fragment so the caller
 * chooses the wrapper (a `<p>`, a checkbox `<label>`). Links open in a new tab so a person
 * mid-signup never loses their form.
 */
export function TermsAgreementText({ message, termsUrl, privacyUrl, }) {
    const parts = [];
    let cursor = 0;
    for (const match of message.matchAll(TAG_PATTERN)) {
        const [whole, tag, text] = match;
        const start = match.index;
        if (start > cursor)
            parts.push(message.slice(cursor, start));
        parts.push(_jsx("a", { href: tag === "terms" ? termsUrl : privacyUrl, target: "_blank", rel: "noopener noreferrer", className: LINK_CLASS, children: text }, start));
        cursor = start + whole.length;
    }
    if (cursor < message.length)
        parts.push(message.slice(cursor));
    return _jsx(_Fragment, { children: parts });
}
TermsAgreementText.displayName = "TermsAgreementText";
//# sourceMappingURL=terms-agreement-text.js.map